import { IAction } from '@faire/web-api--source/indigofair/data/IAction';
import { IElementLoggingData } from '@faire/web-api--source/indigofair/data/IElementLoggingData';
import { IImage } from '@faire/web-api--source/indigofair/data/IImage';
import { IOverlayElement } from '@faire/web-api--source/indigofair/data/IOverlayElement';
import { Radius } from '@faire/web-api--source/indigofair/data/Radius';

export namespace IImageElement {
  /**
   * Return an instance of IImageElement with the provided fields. Any field not
   * listed will be populated with an empty value (an empty array,
   * or undefined, whichever is valid for the type of the value.)
   */
  export const build = (partial?: Partial<IImageElement>): IImageElement =>
    ({
      on_click: [],
      ...(partial ?? {}),
    }) as IImageElement;
}

/**
 * DEPRECATED use SDUIImage
 * @deprecated
 */
export interface IImageElement {
  image: IImage | undefined;
  on_click: Array<IAction>;
  logging_data: IElementLoggingData | undefined;
  overlay: IOverlayElement | undefined;
  corner_radius: keyof typeof Radius | undefined;
}
